import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.agent.management.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_AGENT_ASYNC: `${uid}.saveAgentAsync`,
    SAVE_AGENT_SUCCESS: `${uid}.saveAgentSuccess`,
    SAVE_AGENT_FAILURE: `${uid}.saveAgentFailure`,
    UPDATE_AGENT_ASYNC: `${uid}.updateAgentAsync`,
    UPDATE_AGENT_SUCCESS: `${uid}.updateAgentSuccess`,
    UPDATE_AGENT_FAILURE: `${uid}.updateAgentFailure`,
    GET_ALL_COUNTRY_CODE_ASYNC:`${uid}.getAllCountryCodeAsync`,
    GET_ALL_COUNTRY_CODE_SUCCESS:`${uid}.getAllCountryCodeSuccess`,
    GET_ALL_COUNTRY_CODE_FAILURE:`${uid}.getAllCountryCodeFailure`,
    GET_PARTNER_BY_EMAIL_ASYNC: `${uid}.getPartnerByEmailAsync`,
    GET_PARTNER_BY_EMAIL_SUCCESS: `${uid}.getPartnerByEmailSuccess`,
    GET_PARTNER_BY_EMAIL_FAILURE: `${uid}.getPartnerByEmailFailure`,
    UPDATE_VALUES: `${uid}.updateValues`,
    LOGIN_OTHER_AGENT_ASYNC: `${uid}.loginOtherAgentAsync`,
    LOGIN_OTHER_AGENT_SUCCESS: `${uid}.loginOtherAgentSuccess`,
    LOGIN_OTHER_AGENT_FAILURE: `${uid}.loginOtherAgentFailure`,
    LOGIN_OTHER_TEACHER_ASYNC: `${uid}.loginOtherTeacherAsync`,
    LOGIN_OTHER_TEACHER_SUCCESS: `${uid}.loginOtherTeacherSuccess`,
    LOGIN_OTHER_TEACHER_FAILURE: `${uid}.loginOtherTeacherFailure`,
};

export { ActionTypes };